module.exports = __webpack_public_path__ + "img/poly-1.85a9fb44.png";